import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  LoadingOutlined,
  SolutionOutlined,
  MobileOutlined,
  ControlOutlined,
  FileJpgOutlined,
  DownloadOutlined,
  AuditOutlined,
  ProfileOutlined,
  FileDoneOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  PieChartOutlined,
  BarChartOutlined,
  ApartmentOutlined,
  EllipsisOutlined,
  HolderOutlined,
  MenuOutlined,
  RightSquareOutlined,
  LeftSquareOutlined,
  MenuUnfoldOutlined,
  BarcodeOutlined
} from "@ant-design/icons";

const mapCssProp = {
  "background-color": "backgroundColor",
  "font-color": "color",
  "font-family": "fontFamily",
  "font-size": "fontSize",
  "font-weight": "fontWeight",
  "text-align": "text-align",
  "margin": "margin"
};

export const getStyleProperties = (obj) => {
  let cssProp = {};
  for (let key in obj) {
    if (Object.keys(mapCssProp).indexOf(key) > -1) {
      cssProp[mapCssProp[key]] = obj[key];
    }
  }
  return cssProp;
};

export const deepEqualLineDashValues = (oldValues, newValues) => {
  const oldKeys = Object.keys(oldValues);
  const newKeys = Object.keys(newValues);

  for (const key of newKeys) {
    const val1 = newValues[key];
    if (oldKeys.indexOf(key) < 0) {
      return false;
    }
    const val2 = oldValues[key];

    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqualLineDashValues(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    if (!object2.hasOwnProperty(key)) {
      return false;
    }
    const val2 = object2[key];

    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

const isObject = (object) => {
  return object != null && typeof object === "object";
};

export const removePx = (value) => {
  return typeof value !== "number"
    ? value.indexOf("px") >= 0
      ? parseInt(value.substr(0, value.indexOf("px")))
      : parseInt(value)
    : value;
};

// export const MqttClient = connect(process.env.REACT_APP_MQTT_URL, {
//   username: process.env.REACT_APP_MQTT_USER,
//   password: process.env.REACT_APP_MQTT_PWD,
// });

export const getUrlCode = () => {
  return localStorage.getItem('urlCode');
}


export const createRoute = ({
  route,
  props,
  multiProps,
  params,
  record,
  urlCode,
}) => {
  let urlData = { ...params };
  if (multiProps) {
    multiProps.forEach((prop) => {
      urlData[prop] = record[prop];
    });
  };
  if (props) {
    urlData[props] = record[props];
  }
  let searchParams = new URLSearchParams(urlData);
  let url = `/v02/${urlCode}${route}`;
  if (Object.keys(urlData).length) {
    if (url.includes("?")) {
      url += `&${searchParams}`
    } else {
      url += `?${searchParams}`
    }
  };
  return url;
}

export const icons = {
  EllipsisOutlined,
  HolderOutlined,
  MenuOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  LoadingOutlined,
  SolutionOutlined,
  MobileOutlined,
  ControlOutlined,
  FileJpgOutlined,
  DownloadOutlined,
  AuditOutlined,
  ProfileOutlined,
  FileDoneOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  PieChartOutlined,
  BarChartOutlined,
  ApartmentOutlined,
  RightSquareOutlined,
  LeftSquareOutlined,
  MenuUnfoldOutlined,
  BarcodeOutlined
}